import { useCallback, useEffect, useRef } from 'react'
import * as Sentry from '@sentry/react'
import LogRocket from 'logrocket'

import { config } from '@/config'
import { useUser } from '@/hooks/use-user'

export function LogRocketProvider() {
	const { user } = useUser()
	const logRocketInitialized = useRef(false)

	const identifyUser = useCallback(() => {
		if (user?.username) {
			LogRocket.identify(user.username, {
				name: user.name || '',
				email: user.email || '',
				operatorName: user.portal_operator?.name || '',
			})
		}
	}, [user])

	const connectWithSentry = useCallback(() => {
		LogRocket.getSessionURL((sessionURL) => {
			Sentry.setExtra('sessionURL', sessionURL)
		})
	}, [])

	useEffect(() => {
		if (!user || config.analyticsDisabled) return

		if (config.logrocket.appId && !logRocketInitialized.current) {
			LogRocket.init(config.logrocket.appId)
			logRocketInitialized.current = true
			identifyUser()
			connectWithSentry()
		} else if (logRocketInitialized.current) {
			identifyUser()
		}
	}, [user, identifyUser, connectWithSentry])

	return null
}
